import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { AranDrawerModalService } from '@aran-client/aran-web-ui-toolkit';
import { Store } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { StoreHelperService } from 'src/app/shared/services/store-helper/store-helper.service';
import * as myAccountTypes from 'src/app/shared/types/my-account.types';
import { UpdateInformationType } from 'src/app/shared/types/my-account.types';
import { ErrorMessages } from 'src/app/shared/utils/error-message.utils';
import { MyAccountAction } from 'src/app/store/my-account/my-account.action';

@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss'],
})
export class UpdateComponent implements OnInit {
  @Input() accountDetail$!: Observable<myAccountTypes.User | null>;

  form!: FormGroup<myAccountTypes.UpdateInformationType>;
  errorMessages = ErrorMessages;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private store: Store,
    private aranDrawerModalService: AranDrawerModalService,
    private storeHelperService: StoreHelperService
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      organizationName: this.formBuilder.control(null, Validators.required),
      organizationEmail: this.formBuilder.control(null, [
        Validators.required,
        Validators.email,
      ]),
      organizationAddress: this.formBuilder.control(null, Validators.required),
      organizationWebsite: this.formBuilder.control(null),
      generalSRName: this.formBuilder.control(null, Validators.required),
      generalSRSurName: this.formBuilder.control(null, Validators.required),
      generalSREmail: this.formBuilder.control(null, [
        Validators.required,
        Validators.email,
      ]),
      generalSRPhone: this.formBuilder.control(null),
      technicalSRName: this.formBuilder.control(null, Validators.required),
      technicalSRSurName: this.formBuilder.control(null, Validators.required),
      technicalSREmail: this.formBuilder.control(null, [
        Validators.required,
        Validators.email,
      ]),
      technicalSRPhone: this.formBuilder.control(null),
    });

    this.accountDetail$
      .pipe(
        tap((data) => {
          this.form
            .get('organizationName')
            ?.setValue(data?.organizationName ?? '');
          this.form
            .get('organizationEmail')
            ?.setValue(data?.organizationEmail ?? '');
          this.form
            .get('organizationAddress')
            ?.setValue(data?.organizationAddress ?? '');
          this.form
            .get('organizationWebsite')
            ?.setValue(data?.organizationWebsite ?? '');
          this.form.get('generalSRName')?.setValue(data?.generalSRName ?? '');
          this.form
            .get('generalSRSurName')
            ?.setValue(data?.generalSRSurname ?? '');
          this.form.get('generalSREmail')?.setValue(data?.generalSREmail ?? '');
          this.form.get('generalSRPhone')?.setValue(data?.generalSRPhone ?? '');
          this.form
            .get('technicalSRName')
            ?.setValue(data?.technicalSRName ?? '');
          this.form
            .get('technicalSRSurName')
            ?.setValue(data?.technicalSRSurname ?? '');
          this.form
            .get('technicalSREmail')
            ?.setValue(data?.technicalSREmail ?? '');
          this.form
            .get('technicalSRPhone')
            ?.setValue(data?.technicalSRPhone ?? '');
        })
      )
      .subscribe();
  }

  applyUpdate(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    let body = this.form.value as unknown as UpdateInformationType;

    this.storeHelperService
      .getAllDispatchAndSelect(new MyAccountAction.UpdateUserDetail(body))
      .pipe(
        tap(() => {
          this.aranDrawerModalService.hide();
          this.store.dispatch(new MyAccountAction.GetUserDetail());
        })
      )
      .subscribe();
  }
}
